const sanitizeConf = {
  allowedTags: [
    "b",
    "i",
    "em",
    "strong",
    "code",
    "a",
    "p",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "div",
    "span",
    "img",
    "br",
    "mark",
    "s",
    "sub",
    "sup",
    "u",
  ],
  allowedAttributes: {
    a: ["href", "rel", "target"],
    img: ["src", "width", "height", "srcset"],
    span: ["style", "class", "data-remark-thread-id"],
  },
  parseStyleAttributes: false,
};

const sanitizeConfInline = {
  allowedTags: [
    "b",
    "i",
    "em",
    "strong",
    "code",
    "a",
    "span",
    "img",
    "br",
    "mark",
    "s",
    "sub",
    "sup",
    "u",
  ],
  allowedAttributes: {
    a: ["href", "rel", "target"],
    img: ["src", "width", "height", "srcset"],
    span: ["style", "class", "data-remark-thread-id"],
  },
  parseStyleAttributes: false,
};

export { sanitizeConf, sanitizeConfInline };
